module.exports = __webpack_public_path__ + "static/media/logo-provenExpert-min.aa7db507.webp";